import utils from './../utils.js';
import platform from '../platform/index.js';
export default platform.hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
  write: function write(name, value, expires, path, domain, secure, sameSite) {
    if (typeof document === 'undefined') return;
    var cookie = ["".concat(name, "=").concat(encodeURIComponent(value))];

    if (utils.isNumber(expires)) {
      cookie.push("expires=".concat(new Date(expires).toUTCString()));
    }

    if (utils.isString(path)) {
      cookie.push("path=".concat(path));
    }

    if (utils.isString(domain)) {
      cookie.push("domain=".concat(domain));
    }

    if (secure === true) {
      cookie.push('secure');
    }

    if (utils.isString(sameSite)) {
      cookie.push("SameSite=".concat(sameSite));
    }

    document.cookie = cookie.join('; ');
  },
  read: function read(name) {
    if (typeof document === 'undefined') return null;
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  },
  remove: function remove(name) {
    this.write(name, '', Date.now() - 86400000, '/');
  }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
  write: function write() {},
  read: function read() {
    return null;
  },
  remove: function remove() {}
};